import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, MenuItem, TextField, Typography, useMediaQuery } from '@mui/material';
import { Planos } from '../../pages/home';
import getEmail from '../../functions/getEmail';
import { EmailService } from '../../services/email';
import { toast } from 'react-toastify';
import PhoneNumberInput from '../inputPhoneNumber';

const ContactForm: React.FC<{planoAtual: Planos, setPlanoAtual(planoAtual : string): void}> = ({ planoAtual, setPlanoAtual }) => {

  const instance = new EmailService();

  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    cidade: '',
    plano: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  // telefone input 
  const [phone, setPhone] = useState({ masked: "", unmasked: "" });

  const handlePhoneChange = (maskedValue: string, unmaskedValue: string, name: string) => {
    setPhone({ masked: maskedValue, unmasked: unmaskedValue });

    setFormData({ ...formData, [name]: maskedValue });
  };

  const generateMailToLink = () => {
    const subject = encodeURIComponent(`Solicitação de Plano - ${planoAtual}`);
    const body = encodeURIComponent(
      `Olá,\n\nSegue abaixo as informações para a solicitação de plano:\n\n` +
        `Plano: ${planoAtual === "default" ? "individual" : planoAtual}\n` +
        `Nome: ${formData.nome}\n` +
        `Email: ${formData.email}\n` +
        `Telefone: ${formData.telefone}\n` +
        `Cidade: ${formData.cidade}\n\n` +
        `Atenciosamente,\n${formData.nome}`
    );

    return `mailto:${getEmail()}?subject=${subject}&body=${body}`;
  };

  const [disabled, setDisabled] = useState<boolean>(false);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setDisabled(true);
    //window.open(generateMailToLink(), "_blank");
    const payload = {
      nome: formData.nome,
      email: formData.email,
      cidade: formData.cidade,
      plano: formData.plano,
      telefone: formData.telefone,
    }
    sendMensagem(payload);
  };

  const sendMensagem = (payload: any) => {

    instance
    .send_email_home(payload)
    .then(res => {
      clear();
    })
    .catch(error => {
      console.log('error', error);
      setDisabled(false);
    });

  }
  const clear = () => {

    setFormData({
      nome: '',
      email: '',
      telefone: '',
      cidade: '',
      plano: formData.plano
    });
    
    toast.success('Formulário enviado com sucesso!');

    setDisabled(false);
  }
  const isMobile = useMediaQuery("(max-width:768px)");

  useEffect(() => {
    setFormData(prevState => ({...prevState, plano: planoAtual === "default" || undefined ? "individual" : planoAtual}));
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: '#004387',
        padding: isMobile ? "0" :'50px',
        textAlign: 'center',
        flexDirection: isMobile ? "column" : "row",
        color: 'white',
        display: "flex",
        alignItems: "center",
        justifyContent: "space-evenly"
      }}
    >

      <Box sx={isMobile ? { p: 1 } : { p: 2, pr: 5}}>
        <Typography variant={ isMobile ? "body1" :"h5"} fontWeight="bold" mb={3} textAlign="left">
        Escolha a melhor rede de saúde suplementar de Rondônia, vamos te ajudar!
        </Typography>
        <Typography variant={ isMobile ? "body2" : "h6"} mb={3} textAlign="justify">
        A Innova tem a maior cobertura estadual, atendimento rápido e moderno para a sua família e empresa.
        </Typography>
        <Typography variant="body2" mb={3} textAlign="justify">
        Preencha os dados e simule o seu Plano Innova
        </Typography>
      </Box>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: isMobile ? "95vw" : '500px',
          margin: '1em auto',
          backgroundColor: '#fff',
          padding: "1em",
          borderRadius: "0.5em"
        }}
      >
        <TextField
          select
          size='small'
          variant="outlined"
          label="Planos"
          defaultValue="individual"
          value={planoAtual === "default" ? "individual" : planoAtual}
          onChange={e => setPlanoAtual(e.target.value)}
          fullWidth
          sx={{ backgroundColor: '#fff', color: 'white' }}
        >
          <MenuItem value="individual">Individual</MenuItem>
          <MenuItem value="coletivo">Coletivo</MenuItem>
          <MenuItem value="empresarial">Empresarial</MenuItem>
        </TextField>
        <TextField
          size='small'
          variant="outlined"
          required
          label="Nome"
          name="nome"
          value={formData.nome}
          onChange={handleChange}
          fullWidth
          sx={{ backgroundColor: '#fff', color: 'white' }}
        />
        <TextField
          size='small'
          variant="outlined"
          required
          label="Email"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          fullWidth
          sx={{ backgroundColor: '#fff', color: 'white' }}
        />
        {/* <TextField
          variant="outlined"
          required
          label="Telefone"
          name="telefone"
          type="tel"
          onChange={handleChange}
          fullWidth
          sx={{ backgroundColor: '#fff', color: 'white' }}
        /> */}
        <PhoneNumberInput
          value={formData.telefone}
          onChange={handlePhoneChange}
          name="telefone"
          label='Telefone'
        />
        <TextField
          size='small'
          variant="outlined"
          required
          label="Cidade para qual quer atendimento"
          fullWidth
          name="cidade"
          value={formData.cidade}
          onChange={handleChange}
          sx={{ backgroundColor: '#fff', color: 'white' }}
        />
        <Button
          //component="a"
          //href={generateMailToLink()}
          variant="contained"
          fullWidth
          color="secondary"
          type='submit'
          disabled={disabled}
          //target="_blank"
          //rel="noopener noreferrer"
        > {disabled ? <CircularProgress size={24} color="inherit" /> : '✓ Enviar E-mail'} </Button>
      </Box>
    </Box>
  );
};

export default ContactForm;
